module.exports = __webpack_public_path__ + "img/personal_icon_details_integral@2x.d5fe9449.png";